import { Button, Menu, MenuItem } from '@material-ui/core'
import React, { useState, useEffect, useRef } from 'react'
import { ListItem, List, SwipeableDrawer, Divider } from '@material-ui/core'
import { Link, NavLink, useHistory } from 'react-router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import GavelIcon from '@material-ui/icons/Gavel'
import MenuIcon from '@material-ui/icons/Menu'
import AllInboxIcon from '@material-ui/icons/AllInbox'
import DashboardIcon from '@material-ui/icons/Dashboard'
import MotorcycleIcon from '@material-ui/icons/Motorcycle'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import CloseIcon from '@material-ui/icons/Close'
import MoneyOffIcon from '@material-ui/icons/MoneyOff'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import InfoIcon from '@material-ui/icons/Info'
import SettingsInputSvideoIcon from '@material-ui/icons/SettingsInputSvideo'
// import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode'

import './header.css'
import { useCustomMediaQuery } from '../../../common/components'
import { Dashboard } from '@material-ui/icons'
import { isAuthenticated, userRole } from '../../../Utils/Auth'
import { useSnackbar } from 'notistack'
import CustomInput from '../../atoms/Inputs/CustomInput'
import LanguageSwitcher from '../../../Utils/LanguageManager'
import { useTranslation } from 'react-i18next'
import PrimaryButton from '../../atoms/PrimaryButton'
import SecondaryButton from '../../atoms/SecondaryButton'
import CustomModal from '../../molecules/CustomModal'
import axios from 'axios'
const Header = (props) => {
    const history = useHistory()
    const { t, i18n } = useTranslation()
    const aboutbutton = useRef()
    const [termsAndCondPopup, setTermsAndCondPopup] = useState(false)

    const currentLanguage = i18n.language

    const useStyles = makeStyles({
        list: {
            width: 250,
        },
        fullList: {
            width: 'auto',
        },
    })

    const termsAndCondCancelClickHandler = () => {
        // setAlert('You must Accept Terms and Condition to Bid on Product')
        setTermsAndCondPopup(false)
    }

    const decodeJWT = () => {
        const token = localStorage.getItem('coachToken')

        if (token) {
            const payload = token.split('.')[1]
            const decoded = JSON.parse(atob(payload))

            return decoded
        } else {
            return null
        }
    }

    useEffect(() => {
        if (isAuthenticated()) {
            const decoded = decodeJWT()
            if (decoded) {
                if (
                    localStorage.getItem('termsCheck') != 1 &&
                    decoded.terms_check == 0 &&
                    (decoded?.role == 0 || decoded?.role == 4)
                ) {
                    setTermsAndCondPopup(true)
                }
            } else {
                console.log('ERROR')
            }
        }
    }, [isAuthenticated()])

    const termsAndCondAcceptClickHandler = async () => {
        if (!isAuthenticated()) {
        } else {
            const decoded = decodeJWT()
            if (decoded) {
                const userID = decoded?.id

                const body = {
                    site_id: process.env.REACT_APP_SITE_ID,
                    user_id: userID,
                    terms_check: 1,
                }

                axios
                    .put(`${process.env.REACT_APP_MOBILE_API_URL}/update_terms_condition`, body)
                    .then(function (response) {
                        try {
                            if (response.data.success) {
                                localStorage.setItem('termsCheck', 1)
                                setTermsAndCondPopup(false)
                            }
                        } catch (e) {
                            console.error('Error while processing API response:', e)
                        }
                    })
                    .catch((error) => {
                        console.error('Error during API call:', error)
                    })
            }
        }
    }

    const [headerClassName, setHeaderClassName] = useState('header')

    const [anchorEl, setAnchorEl] = React.useState({ anchorEl: undefined, open: false })

    const [about, setAbout] = React.useState({ anchorEl: undefined, open: false })

    const [login, setLogin] = React.useState({ anchorEl: undefined, open: false })

    const { enqueueSnackbar } = useSnackbar()
    const [searchText, setSearchText] = useState('')
    const [user, setUser] = React.useState(
        localStorage.getItem('coachUser') ? JSON.parse(localStorage.getItem('coachUser')) : {},
    )

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem('coachUser')))
    }, [localStorage.getItem('coachUser')])

    useEffect(() => {
        window.addEventListener('scroll', listenScrollEvent)
        setUser(
            localStorage.getItem('coachUser') ? JSON.parse(localStorage.getItem('coachUser')) : {},
        )
        return () => window.removeEventListener('scroll', listenScrollEvent)
    }, [])
    const getInitials = (fullName) => {
        if (!fullName) return ''

        const names = fullName.trim().split(' ')
        const firstInitial = names[0]?.charAt(0).toUpperCase() || ''
        const lastInitial = names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : ''

        return firstInitial + lastInitial
    }

    useEffect(() => {
        if (window.location.href.includes('#about')) {
            if (window.innerWidth > 600) {
                window.scrollTo(0, 0)
                // aboutbutton.current.click()
                {
                    console.log('aboutbuttonRef', aboutbutton.current)
                }
                setAbout({
                    open: true,
                    anchorEl: aboutbutton.current,
                })
            } else {
                toggleDrawerauto()
            }
        }
    }, [window.location.href])

    const listenScrollEvent = (event) => {
        if (window.scrollY > 0) {
            return setHeaderClassName('changeColor')
        } else if (window.scrollY < 70) {
            return setHeaderClassName('header')
        }
    }

    const logout = () => {
        localStorage.removeItem('coachToken')
        localStorage.removeItem('coachUser')
        localStorage.removeItem('termsCheckSeller')
        localStorage.removeItem('termsCheck')
        localStorage.removeItem('autoLogin')
        enqueueSnackbar('Logged out successfully!', {
            variant: 'success',
        })
        window.location.href = '/'
    }
    const handleAuctionClick = (event) => {
        // setAnchorEl(event.currentTarget)
        setAnchorEl({ open: true, anchorEl: event.currentTarget })
    }

    const handleAuctionClose = () => {
        setAnchorEl({ ...anchorEl, open: false })
    }

    const handleAboutCgClick = (event) => {
        console.log('test', event.currentTarget)
        setAbout({ open: true, anchorEl: event.currentTarget })
    }

    const handleAboutCgClose = () => {
        setAbout({ ...about, open: false })
    }

    const handleLoginClick = (event) => {
        setLogin({ open: true, anchorEl: event.currentTarget })
    }

    const handleLoginClose = () => {
        setLogin({ ...login, open: false })
    }

    const handleLiveAuctions = () => {
        history.push('/liveauction')
        handleAuctionClose()
    }

    const handlePastAuctions = () => {
        history.push('/pastauction')
        handleAuctionClose()
    }
    // Swipeable drawer
    const classes = useStyles()
    const [state, setState] = React.useState({
        right: false,
    })

    const toggleDrawerauto = () => {
        setState({ ...state, ['right']: true })
    }

    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            console.log('valuesss--->anchor', anchor, open)
            return
        }
        console.log('valuesss--->anchor', anchor, open)
        setState({ ...state, [anchor]: open })
    }
    const white = {
        color: 'white',
    }
    const [value, setvalue] = useState(false)

    const handleSearch = () => {
        history.push(`/liveauction?search=${searchText}`)
    }

    const list = (anchor) => (
        <div
            className={clsx(
                classes.list,
                {
                    [classes.fullList]: anchor === 'top' || anchor === 'bottom',
                },
                'commonDashNavSlider ',
            )}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className="SideLogo">
                <Link to="/home">
                    <img
                        src={
                            currentLanguage == 'for_english'
                                ? '/assets/svg/Carzaar-Logo_en.svg'
                                : '/assets/svg/Carzaar-Logo-swe.svg'
                        }
                        className="headerLogo"
                        alt="carZaar"
                    />
                </Link>
                <Button onClick={toggleDrawer(anchor, false)}>
                    <CloseIcon fontSize="small" style={white} />
                </Button>
            </div>
            <List>
                {isAuthenticated() && (
                    <ListItem button>
                        <NavLink
                            className="dashboardNav"
                            to={
                                user?.role == 0
                                    ? '/dashboard/buyer/profile'
                                    : user?.role == 1
                                    ? '/dashboard/seller/profile'
                                    : '/dashboard/ambassador/profile'
                            }
                            activeClassName="active"
                        >
                            <ListItemIcon>
                                <AccountCircleIcon />
                                Hi, <span className="usreNameelli">{user?.first_name}</span>
                            </ListItemIcon>
                        </NavLink>
                    </ListItem>
                )}
                <ListItem button>
                    <NavLink className="dashboardNav" to="/home" activeClassName="active">
                        <ListItemIcon>
                            <GavelIcon />
                            Live Auctions
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink className="dashboardNav" to="/pastauction" activeClassName="active">
                        <ListItemIcon>
                            <MoneyOffIcon />
                            Past Auctions
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                {isAuthenticated() && (
                    <ListItem button>
                        <NavLink
                            className="dashboardNav"
                            to={
                                user?.role == 0
                                    ? '/dashboard/buyer/myauction'
                                    : user?.role == 1
                                    ? '/dashboard/seller/myauction'
                                    : '/dashboard/ambassador/myauction'
                            }
                            activeClassName="active"
                        >
                            <ListItemIcon>
                                <DashboardIcon />
                                {t('dashboard')}
                            </ListItemIcon>
                        </NavLink>
                    </ListItem>
                )}

                <ListItem button>
                    <NavLink
                        className="dashboardNav"
                        to={!isAuthenticated() ? '/login' : user?.role == 0 ? '/login' : '/'}
                        activeClassName="active"
                    >
                        <ListItemIcon>
                            <MotorcycleIcon />
                            {t('submit_a_vehicle')}
                        </ListItemIcon>
                    </NavLink>
                </ListItem>

                <ListItem button>
                    <NavLink className="dashboardNav" to="/whatcoachgavel" activeClassName="active">
                        <ListItemIcon>
                            <HelpOutlineIcon />
                            What Is Coach & Gavel?
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink className="dashboardNav" to="/whycoachgavel" activeClassName="active">
                        <ListItemIcon>
                            <HelpOutlineIcon />
                            Why Coach & Gavel?
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink className="dashboardNav" to="/howitworks" activeClassName="active">
                        <ListItemIcon>
                            <InfoIcon />
                            How Does It Work?
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink className="dashboardNav" to="/joinemaillist" activeClassName="active">
                        <ListItemIcon>
                            <AllInboxIcon />
                            Join The E-Mail List
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                {/* <ListItem button>
                    <NavLink className="dashboardNav" to="/gearstore" activeClassName="active">
                        <ListItemIcon>
                            <SettingsInputSvideoIcon />
                            Gear Store
                        </ListItemIcon>
                    </NavLink>
                </ListItem> */}
                <ListItem button>
                    <NavLink className="dashboardNav" to="/privacy_policy" activeClassName="active">
                        <ListItemIcon>
                            <ChromeReaderModeIcon />
                            {t('privacy_policy')}
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink className="dashboardNav" to="/terms" activeClassName="active">
                        <ListItemIcon>
                            <ChromeReaderModeIcon />
                            Terms & Conditions
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <Divider />
                {!isAuthenticated() && (
                    <ListItem button>
                        <Button
                            variant="contained"
                            className="sideNavBtn"
                            color="primary"
                            href="/login"
                        >
                            {t('login_upper')}
                        </Button>
                    </ListItem>
                )}
                {isAuthenticated() && (
                    <ListItem button>
                        <Button
                            variant="contained"
                            className="sideNavBtn"
                            color="primary"
                            onClick={logout}
                        >
                            Logout
                        </Button>
                    </ListItem>
                )}
            </List>
        </div>
    )

    // Swipeable drawer end
    // const isTabletMid = useCustomMediaQuery('(max-width: 700px)')
    // const isTabletMid = useMediaQuery({ query: '(max-width: 700px)' })
    // const dNone = { style: { display: 'none' } }
    const unLogged = () => (
        <React.Fragment>
            <div className="searchSection">
                <Link to="/">
                    <img
                        src={
                            currentLanguage == 'for_english'
                                ? '/assets/svg/Carzaar-Logo_en.svg'
                                : '/assets/svg/Carzaar-Logo-swe.svg'
                        }
                        className="headerLogo"
                        alt="carZaar"
                    />
                </Link>

                <CustomInput
                    placeholder={`${t('search_lots_text')}...`}
                    name="search"
                    labelClass="labelSearch"
                    inputClassName="searchbar"
                    value={searchText}
                    endAdornment={
                        <span
                            className="material-icons searchbar-button"
                            style={{ cursor: 'pointer' }}
                            onClick={handleSearch}
                        >
                            search
                        </span>
                    }
                    onChange={(e) => setSearchText(e.target.value)}
                />
            </div>
            <div className="navigationSection">
                <NavLink className="headerLink" to="/home">
                    {t('live_now')}
                </NavLink>

                <LanguageSwitcher />
                <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    className="light-prim header-menu"
                >
                    <NavLink
                        className="headerLink"
                        to="/registration_step_1"
                        activeClasName="active"
                    >
                        {t('register')}
                    </NavLink>
                </Button>
                <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    className="light-sec header-menu"
                >
                    <NavLink className="headerLink" to="/login" activeClasName="active">
                        {t('login_upper')}
                    </NavLink>
                    {/* /
                <NavLink className="headerLink" to="/registration_step_1" activeClasName="active">
                    Register
                </NavLink> */}
                </Button>
            </div>
        </React.Fragment>
    )
    const buyer = () => (
        <React.Fragment>
            <div className="searchSection">
                <Link to="/home">
                    <img
                        src={
                            currentLanguage == 'for_english'
                                ? '/assets/svg/Carzaar-Logo_en.svg'
                                : '/assets/svg/Carzaar-Logo-swe.svg'
                        }
                        className="headerLogo"
                        alt="carZaar"
                    />
                </Link>
                <CustomInput
                    placeholder={`${t('search_lots_text')}...`}
                    name="search"
                    labelClass="labelSearch"
                    inputClassName="searchbar"
                    value={searchText}
                    endAdornment={
                        <span
                            className="material-icons searchbar-button"
                            style={{ cursor: 'pointer' }}
                            onClick={handleSearch}
                        >
                            search
                        </span>
                    }
                    onChange={(e) => setSearchText(e.target.value)}
                />
            </div>
            <div className="navigationSection">
                {/* <NavLink className="headerLink" to="/home">
                    Home
                </NavLink> */}

                <NavLink className="headerLink" to="/home">
                    {t('live_now')}
                </NavLink>
                <LanguageSwitcher />
                <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    className="light-white header-menu custProfileMenu"
                    onClick={handleLoginClick}
                >
                    {getInitials(`${user?.first_name} ${user?.last_name}`)}
                    {/* Hi, {user.first_name} | {user.role.toUpperCase()} <ExpandMoreIcon /> */}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={login.anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={login.open}
                    onClose={handleLoginClose}
                    // className={props.classes.menu}
                >
                    <MenuItem onClick={handleLoginClose}>
                        <NavLink className="headerLink" to="/dashboard/buyer/profile">
                            {t('my_profile')}
                        </NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleLoginClose}>
                        <NavLink className="headerLink" to="/dashboard/buyer/mylots">
                            {t('my_dashboard')}
                        </NavLink>
                    </MenuItem>
                    <MenuItem onClick={logout}>{t('logout')}</MenuItem>
                </Menu>
            </div>
        </React.Fragment>
    )
    const seller = () => (
        <React.Fragment>
            <div className="searchSection">
                <Link to="/">
                    <img
                        src={
                            currentLanguage == 'for_english'
                                ? '/assets/svg/Carzaar-Logo_en.svg'
                                : '/assets/svg/Carzaar-Logo-swe.svg'
                        }
                        className="headerLogo"
                        alt="carZaar"
                    />
                </Link>
            </div>
            <div className="navigationSection">
                <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    className="light-white header-menu"
                >
                    <NavLink className="headerLink" to="/" activeClasName="active">
                        {t('submit_a_vehicle')}
                    </NavLink>
                </Button>

                <LanguageSwitcher />

                <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    className="light-white header-menu custProfileMenu"
                    onClick={handleLoginClick}
                >
                    <span className="usreNameelli">
                        {getInitials(`${user?.first_name} ${user?.last_name}`)}
                    </span>
                    {/* <ExpandMoreIcon /> */}
                    {/* Hi, {user.first_name} | {user.role.toUpperCase()} <ExpandMoreIcon /> */}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={login.anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={login.open}
                    onClose={handleLoginClose}
                    // className={props.classes.menu}
                >
                    <MenuItem onClick={handleLoginClose}>
                        <NavLink className="headerLink" to="/dashboard/seller/profile">
                            {t('my_profile')}
                        </NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleLoginClose}>
                        <NavLink className="headerLink" to="/dashboard/seller/mylots">
                            {t('my_dashboard')}
                        </NavLink>
                    </MenuItem>
                    <MenuItem onClick={logout}>{t('logout')}</MenuItem>
                </Menu>
            </div>
        </React.Fragment>
    )

    const ambassador = () => (
        <React.Fragment>
            <div className="searchSection">
                <Link to="/dashboard/ambassador/mylots">
                    <img
                        src={
                            currentLanguage == 'for_english'
                                ? '/assets/svg/Carzaar-Logo_en.svg'
                                : '/assets/svg/Carzaar-Logo-swe.svg'
                        }
                        className="headerLogo"
                        alt="carZaar"
                    />
                </Link>
            </div>
            <div className="navigationSection">
                <LanguageSwitcher />
                <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    className="light-white header-menu custProfileMenu"
                    onClick={handleLoginClick}
                >
                    <span className="usreNameelli">
                        {getInitials(`${user?.first_name} ${user?.last_name}`)}
                    </span>
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={login.anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={login.open}
                    onClose={handleLoginClose}
                    // className={props.classes.menu}
                >
                    <MenuItem onClick={handleLoginClose}>
                        <NavLink className="headerLink" to="/dashboard/ambassador/profile">
                            {t('my_profile')}
                        </NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleLoginClose}>
                        <NavLink className="headerLink" to="/dashboard/ambassador/mylots">
                            {t('my_dashboard')}
                        </NavLink>
                    </MenuItem>
                    <MenuItem onClick={logout}>{t('logout')}</MenuItem>
                </Menu>
            </div>
        </React.Fragment>
    )
    return (
        <>
            <div
                className={`header-common header ${props.hdrCls} ${
                    window.scrollY >= '5' ? 'white' : 'old'
                }`}
            >
                {/* {console.log(isTabletMid, 'isTabletMid')} */}
                <div className={`${useCustomMediaQuery('(max-width: 700px)') ? '' : 'd-none'} `}>
                    <div
                        maxScroll={200}
                        className={`responsableHeader ${window.scrollY >= '5' ? 'white' : 'old'}`}
                    >
                        <Link to="/">
                            <img
                                src={
                                    currentLanguage == 'for_english'
                                        ? '/assets/svg/Carzaar-Logo_en.svg'
                                        : '/assets/svg/Carzaar-Logo-swe.svg'
                                }
                                className="headerLogo"
                                alt="carZaar"
                            />
                        </Link>
                        {['right'].map((anchor) => (
                            <React.Fragment key={anchor}>
                                <Button onClick={toggleDrawer(anchor, true)}>
                                    <MenuIcon style={{ color: 'var(--secondary-color)' }} />
                                </Button>
                                <SwipeableDrawer
                                    anchor={anchor}
                                    open={state[anchor]}
                                    onClose={toggleDrawer(anchor, false)}
                                    onOpen={toggleDrawer(anchor, true)}
                                >
                                    {list(anchor)}
                                </SwipeableDrawer>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                <div className="customContainer d-flex justify-content-center align-items-center">
                    {isAuthenticated()
                        ? user?.role == 0
                            ? buyer()
                            : user?.role == 1
                            ? seller()
                            : ambassador()
                        : unLogged()}
                </div>
            </div>

            <CustomModal
                open={termsAndCondPopup}
                // handleClose={termsAndCondCancelClickHandler}
                modaltitle={t('terms')}
                disableBackdropClick
                footer={
                    <>
                        <PrimaryButton label={'Confirm'} onClick={termsAndCondAcceptClickHandler} />
                        {/* <SecondaryButton
                            label={'Cancel'}
                            onClick={termsAndCondCancelClickHandler}
                        /> */}
                    </>
                }
            >
                <div
                    className="terms"
                    dangerouslySetInnerHTML={{
                        __html:
                            decodeJWT()?.role == 0
                                ? t('buyertermsandconditions')
                                : decodeJWT()?.role == 4
                                ? t('ambassadortermsandconditions')
                                : '',
                    }}
                ></div>
            </CustomModal>
        </>
    )
    const MobileHeader = () => {
        ;<div className={`${useCustomMediaQuery('(max-width: 700px)') ? '' : 'd-none'}`}>
            <div
                maxScroll={200}
                className={`responsableHeader ${window.scrollY >= '5' ? 'white' : 'old'}`}
            >
                <Link to="/">
                    <img
                        src={
                            currentLanguage == 'for_english'
                                ? '/assets/svg/Carzaar-Logo_en.svg'
                                : '/assets/svg/Carzaar-Logo-swe.svg'
                        }
                        className="headerLogo"
                        alt="carZaar"
                    />
                </Link>
                {['right'].map((anchor) => (
                    <React.Fragment key={anchor}>
                        <Button onClick={toggleDrawer(anchor, true)}>
                            <MenuIcon />
                        </Button>
                        <SwipeableDrawer
                            anchor={anchor}
                            open={state[anchor]}
                            onClose={toggleDrawer(anchor, false)}
                            onOpen={toggleDrawer(anchor, true)}
                        >
                            {list(anchor)}
                        </SwipeableDrawer>
                    </React.Fragment>
                ))}
            </div>
        </div>
    }
}

export default Header
